import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import {
  checkErrorStateExists,
  formStateHandler,
} from "../../../../utils/utils";
import ChipInputSelect from "../../../../framework/ChipInputSelect";
import GlobalContext from "../../../../framework/GlobalContext";
import SelectInput from "../../../../framework/SelectInput";
import TextInput from "../../../../framework/TextInput";
import {
  calculationTypes,
  dueDateTypes,
  distributorTypes,
} from "../../../../utils/constant";
import { searchManufacturer } from "../../../../services/manufacturer-services";
import _ from "lodash";
import NumberInput from "../../../../framework/NumberInput";
import { displayToast } from "../../../../framework/toast/toastUtils";
import Switch from "../../../../framework/Switch";
const GeneralTab = ({
  validateForm = () => {},
  removeErrorStateOnChange = () => {},
}) => {
  const addDistributorNameRef = useRef();
  const addDistributorShortNameRef = useRef();
  const addDistributorLockRef = useRef();
  const addDistributorContactRef = useRef();
  const addDistributorLandLineRef = useRef();
  const addDistributorAddressRef = useRef();
  const addDistributorBuildingNameRef = useRef();
  const addDistributorLocalityRef = useRef();
  const addDistributorLandmarkRef = useRef();
  const addDistributorPincodeRef = useRef();
  const addDistributorCityRef = useRef();
  const addDistributorAreaRef = useRef();
  const addDistributorRegionRef = useRef();
  const addDistributorZoneRef = useRef();
  const addDistributorCountryRef = useRef();
  const addDistributorLatLongRef = useRef();
  const addDistributorSalesEmailRef = useRef();
  const addDistributorPurchaseEmailRef = useRef();
  const addDistributorCalculationTypeRef = useRef();
  const addDistributorDueDateTypeRef = useRef();
  const addDistributorTypeRef = useRef();
  const addDistributorCreditDaysRef = useRef();
  const addDistributorManufacturersRef = useRef();
  const [calculationType, setCalculationType] = useState(null);
  const [dueDateType, setDueDateType] = useState(null);
  const [distributorType, setDistributorType] = useState(null);
  const [selectedManufactures, setSelectedManufactures] = useState([]);
  const [manufactures, setManufactures] = useState([]);
  const [errorStates, setErrorStates] = useState({});
  const withPhoneCap = ({ value }) => value.length <= 10;
  const withPincodeCap = ({ value }) => value.length <= 6;
  const withDaysCap = ({ value }) => value.length <= 3;
  const { formState, errorState } = useSelector(
    (state) => state.commonReducer.common.addDistributor
  );
  const dispatch = useDispatch();
  const [localFormState, setLocalFormState] = useState(null);
  const { setCurrentComponent } = useContext(GlobalContext);
  const dispatchFormState = (newState) => {
    dispatch({
      type: "set_add_distributor_form_state",
      payload: newState,
    });
  };
  const debounceDispatchFormState = _.debounce(dispatchFormState, 1);
  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      // if (fieldName === "contact") {
      //   if (!fieldValue || fieldValue.length <= 10) {
      //     newFormState = {
      //       ...newFormState,
      //       contactError:
      //         "Contact is required and must be at least 10 digits long",
      //     };
      //   } else {
      //     newFormState = { ...newFormState, contactError: null };
      //   }
      // }
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );
  const manufacturerChangedHandler = (event, value, reason) => {
    if (value?.length > 2) {
      searchManufacturer(`manufacturerName=${value.trim()}`).then(
        (response) => {
          let result = Array.isArray(response?.result?.rows)
            ? response.result.rows
            : [];
          result.map((m) => {
            return {
              manufacturerId: m.manufacturerId,
              manufacturerName: m.manufacturerName,
            };
          });
          setManufactures([...result, ...selectedManufactures]);
        }
      );
    }
  };
  const initializeForm = useCallback((formState) => {
    if (formState) {
      addDistributorNameRef.current.value = formState.distributorName || "";
      addDistributorShortNameRef.current.value = formState.srtCode || "";
      addDistributorLockRef.current.value = formState.isLocked || false;
      addDistributorAddressRef.current.value = formState.address || "";
      addDistributorBuildingNameRef.current.value =
        formState.buildingName || "";
      addDistributorLocalityRef.current.value = formState.locality || "";
      addDistributorLandmarkRef.current.value = formState.landmark || "";
      addDistributorPincodeRef.current.value = formState.pincode || "";
      addDistributorCityRef.current.value = formState.city || "";
      addDistributorAreaRef.current.value = formState.area || "";
      addDistributorRegionRef.current.value = formState.region || "";
      addDistributorZoneRef.current.value = formState.zone || "";
      addDistributorCountryRef.current.value = formState.country || "";
      addDistributorLatLongRef.current.value = formState.latLong || "";
      addDistributorContactRef.current.value = formState.contact || "";
      addDistributorLandLineRef.current.value = formState.landlineNumber || "";
      addDistributorSalesEmailRef.current.value = formState.sendEmail || "";
      addDistributorPurchaseEmailRef.current.value = formState.email || "";
      if (formState.manufacturers) {
        const formStateManufacturers = formState.manufacturers.map((m) => {
          return {
            manufacturerId: m.manufacturerId,
            manufacturerName: m.manufacturerName,
          };
        });
        setManufactures(formStateManufacturers);
        setSelectedManufactures(formStateManufacturers);
      }
      if (formState.calculationType !== null) {
        setCalculationType(
          (prev) =>
            calculationTypes.filter(
              (c) => c.id === formState?.calculationType
            )[0]
        );
      }
      if (formState.dueDateType !== null) {
        setDueDateType(
          (prev) =>
            dueDateTypes.filter((d) => d.id === formState?.dueDateType)[0]
        );
      }
      if (formState.distributorType !== null) {
        setDistributorType(
          (prev) =>
            distributorTypes.filter(
              (t) => t.id === formState?.distributorType
            )[0]
        );
      }
    }
  }, []);
  useEffect(() => {
    addDistributorNameRef.current.focus({ preventScroll: true });
  }, [addDistributorNameRef]);
  useEffect(() => {
    if (formState && !localFormState) {
      setTimeout(() => {
        setLocalFormState(formState);
        initializeForm(formState);
      }, 100);
    }
  }, [localFormState, initializeForm, formState]);
  return (
    <Grid
      sx={{
        margin: "5px 0px 5px -10px",
        width: "100%",
      }}
      container
      columnSpacing={2}
      rowSpacing={2.5}
      columns={12}
    >
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_name"
          name="distributorName"
          ref={addDistributorNameRef}
          value={formState?.distributorName || ""}
          label="Distributor Name"
          onFocus={() => setCurrentComponent("add_distributor_name")}
          onChange={(e) => {
            const sanitizedDistName = e.target.value.replace(
              /[^a-zA-Z0-9\s-]/g,
              ""
            );
            handleFormChange("distributorName", sanitizedDistName);
            removeErrorStateOnChange("add_distributor_name");
          }}
          onBlur={() => validateForm("distributorName", formState, errorState)}
          maxInputLength={65000}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_building_name",
              left: "",
              right: "add_distributor_short_name",
            }),
          }}
          required={true}
          error={checkErrorStateExists("add_distributor_name", errorState)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_short_name"
          name="srtCode"
          ref={addDistributorShortNameRef}
          value={formState?.srtCode || ""}
          label="Short Name"
          onFocus={() => setCurrentComponent("add_distributor_short_name")}
          onChange={(e) => {
            handleFormChange("srtCode", e.target.value);
            removeErrorStateOnChange("add_distributor_short_name");
          }}
          maxInputLength={1000}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_locality",
              left: "add_distributor_name",
              right: "add_distributor_contact",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput
          id="add_distributor_contact"
          name="contact"
          ref={addDistributorContactRef}
          label="Contact"
          isAllowed={withPhoneCap}
          allowNegative={false}
          decimalScale={0}
          onFocus={() => setCurrentComponent("add_distributor_contact")}
          value={localFormState?.contact}
          onBlur={() => validateForm("contact", localFormState, errorState)}
          onChange={(e) => {
            setLocalFormState((prev) => {
              return { ...prev, contact: e.target.value };
            });
            handleFormChange("contact", e.target.value || null);
            removeErrorStateOnChange("add_distributor_contact");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_landmark",
              left: "add_distributor_short_name",
              right: "add_distributor_address",
            }),
          }}
          required={!formState?.landlineNumber}
          error={checkErrorStateExists("add_distributor_contact", errorState)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_landline"
          name="landline"
          ref={addDistributorLandLineRef}
          label="Phone/Landline Number"
          onFocus={() => setCurrentComponent("add_distributor_landline")}
          value={formState?.landlineNumber}
          onBlur={() => validateForm("landlineNumber", formState, errorState)}
          onChange={(e) => {
            if (e.target.value?.length > 20) return;
            const landlineRegex = /^[0-9]*$/;
            if (!landlineRegex.test(e.target.value)) {
              return;
            }
            handleFormChange("landlineNumber", e.target.value || null);
            removeErrorStateOnChange("add_distributor_landline");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_landmark",
              left: "add_distributor_short_name",
              right: "add_distributor_address",
            }),
          }}
          required={!localFormState?.contact}
          error={checkErrorStateExists("add_distributor_landline", errorState)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_address"
          name="address"
          ref={addDistributorAddressRef}
          value={formState?.address || ""}
          label="Address"
          onFocus={() => setCurrentComponent("add_distributor_address")}
          onChange={(e) => {
            handleFormChange("address", e.target.value);
            removeErrorStateOnChange("add_distributor_address");
          }}
          onBlur={() => validateForm("address", formState, errorState)}
          required
          maxInputLength={1000}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_pincode",
              left: "add_distributor_contact",
              right: "add_distributor_building_name",
            }),
          }}
          error={checkErrorStateExists("add_distributor_address", errorState)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_building_name"
          name="buildingName"
          ref={addDistributorBuildingNameRef}
          value={formState?.buildingName || ""}
          label="Building Name"
          onFocus={() => setCurrentComponent("add_distributor_building_name")}
          onChange={(e) => {
            handleFormChange("buildingName", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_name",
              down: "add_distributor_city",
              left: "add_distributor_address",
              right: "add_distributor_locality",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_locality"
          name="locality"
          ref={addDistributorLocalityRef}
          value={formState?.locality || ""}
          label="Locality"
          onFocus={() => setCurrentComponent("add_distributor_locality")}
          onChange={(e) => {
            handleFormChange("locality", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_short_name",
              down: "add_distributor_area",
              left: "add_distributor_building_name",
              right: "add_distributor_landmark",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_landmark"
          name="landmark"
          ref={addDistributorLandmarkRef}
          value={formState?.landmark || ""}
          label="Landmark"
          onFocus={() => setCurrentComponent("add_distributor_landmark")}
          onChange={(e) => {
            handleFormChange("landmark", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_contact",
              down: "add_distributor_region",
              left: "add_distributor_locality",
              right: "add_distributor_pincode",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput
          id="add_distributor_pincode"
          ref={addDistributorPincodeRef}
          name="pincode"
          label="Pincode"
          isAllowed={withPincodeCap}
          value={formState?.pincode || ""}
          onFocus={() => setCurrentComponent("add_distributor_pincode")}
          onBlur={(e) => {
            const pinCode = formState?.pincode;
            if (!pinCode || pinCode.toString().length !== 6) {
              displayToast({
                type: "error",
                title: "Please enter a valid 6-digit pincode.",
              });
            }
          }}
          required
          allowNegative={false}
          onValueChange={(values, e) => {
            handleFormChange("pincode", values.floatValue);
            if (errorStates?.pincode)
              setErrorStates((prev) => {
                return { ...prev, pincode: false };
              });
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_address",
              down: "add_distributor_zone",
              left: "add_distributor_landmark",
              right: "add_distributor_city",
            }),
          }}
          error={errorStates?.pincode}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_city"
          name="city"
          ref={addDistributorCityRef}
          value={formState?.city || ""}
          label="City"
          onFocus={() => setCurrentComponent("add_distributor_city")}
          onChange={(e) => {
            handleFormChange("city", e.target.value);
            removeErrorStateOnChange("add_distributor_city");
          }}
          onBlur={() => validateForm("city", formState, errorState)}
          required
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_building_name",
              down: "add_distributor_country",
              left: "add_distributor_pincode",
              right: "add_distributor_area",
            }),
          }}
          error={checkErrorStateExists("add_distributor_city", errorState)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_area"
          name="area"
          ref={addDistributorAreaRef}
          value={formState?.area || ""}
          label="Area"
          onFocus={() => setCurrentComponent("add_distributor_area")}
          onChange={(e) => {
            handleFormChange("area", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_locality",
              down: "add_distributor_lat_long",
              left: "add_distributor_city",
              right: "add_distributor_region",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_region"
          name="region"
          ref={addDistributorRegionRef}
          value={formState?.region || ""}
          label="Region"
          onFocus={() => setCurrentComponent("add_distributor_region")}
          onChange={(e) => {
            handleFormChange("region", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_landmark",
              down: "add_distributor_sales_email",
              left: "add_distributor_area",
              right: "add_distributor_zone",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_zone"
          name="zone"
          ref={addDistributorZoneRef}
          value={formState?.zone || ""}
          label="Zone"
          onFocus={() => setCurrentComponent("add_distributor_zone")}
          onChange={(e) => {
            handleFormChange("zone", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_pincode",
              down: "add_distributor_purchase_email",
              left: "add_distributor_region",
              right: "add_distributor_country",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_country"
          name="country"
          ref={addDistributorCountryRef}
          value={formState?.country || ""}
          label="Country"
          onFocus={() => setCurrentComponent("add_distributor_country")}
          onChange={(e) => {
            handleFormChange("country", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_city",
              down: "add_distributor_calculation_type",
              left: "add_distributor_zone",
              right: "add_distributor_lat_long",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_lat_long"
          name="latLong"
          ref={addDistributorLatLongRef}
          value={formState?.latLong || ""}
          label="Lat/Long"
          onFocus={() => setCurrentComponent("add_distributor_lat_long")}
          onChange={(e) => {
            handleFormChange("latLong", e.target.value);
          }}
          maxInputLength={65000}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_area",
              down: "add_distributor_due_date_type",
              left: "add_distributor_country",
              right: "add_distributor_sales_email",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_sales_email"
          name="sendEmail"
          ref={addDistributorSalesEmailRef}
          value={formState?.sendEmail || ""}
          label="Sales Email"
          onFocus={() => setCurrentComponent("add_distributor_sales_email")}
          onChange={(e) => {
            handleFormChange("sendEmail", e.target.value);
            removeErrorStateOnChange("add_distributor_sales_email");
          }}
          onBlur={() => validateForm("sendEmail", formState, errorState)}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_zone",
              down: "add_distributor_type",
              left: "add_distributor_lat_long",
              right: "add_distributor_purchase_email",
            }),
          }}
          error={checkErrorStateExists(
            "add_distributor_sales_email",
            errorState
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_purchase_email"
          name="email"
          ref={addDistributorPurchaseEmailRef}
          value={formState?.email || ""}
          label="Purchase Email"
          onFocus={() => setCurrentComponent("add_distributor_purchase_email")}
          onBlur={() => validateForm("email", formState, errorState)}
          onChange={(e) => {
            handleFormChange("email", e.target.value);
            removeErrorStateOnChange("add_distributor_purchase_email");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_country",
              down: "add_distributor_credit_days",
              left: "add_distributor_sales_email",
              right: "add_distributor_calculation_type",
            }),
          }}
          error={checkErrorStateExists(
            "add_distributor_purchase_email",
            errorState
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          id="add_distributor_calculation_type"
          name="calculationType"
          ref={addDistributorCalculationTypeRef}
          label="Calculation Type"
          onFocus={() =>
            setCurrentComponent("add_distributor_calculation_type")
          }
          options={calculationTypes}
          isOptionEqualToValue={(option, value) => option.label === value.label}
          value={calculationType || null}
          getOptionLabel={(option) => option.label}
          onChange={(event, option) => {
            setCalculationType(option);
            handleFormChange("calculationType", null, true, { ...option });
          }}
          markers={JSON.stringify({
            left: "add_distributor_purchase_email",
            right: "add_distributor_due_date_type",
          })}
        />
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          id="add_distributor_due_date_type"
          name="dueDateType"
          ref={addDistributorDueDateTypeRef}
          label="Due Date Type"
          onFocus={() => setCurrentComponent("add_distributor_due_date_type")}
          options={dueDateTypes}
          isOptionEqualToValue={(option, value) => option.label === value.label}
          value={dueDateType || null}
          getOptionLabel={(option) => option.label}
          onChange={(event, option) => {
            setDueDateType(option);
            handleFormChange("dueDateType", null, true, { ...option });
          }}
          markers={JSON.stringify({
            left: "add_distributor_calculation_type",
            right: "add_distributor_type",
          })}
        />
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          id="add_distributor_type"
          name="distributorType"
          ref={addDistributorTypeRef}
          label="Distributor Type"
          onFocus={() => setCurrentComponent("add_distributor_type")}
          options={distributorTypes}
          isOptionEqualToValue={(option, value) => option.label === value.label}
          value={distributorType || null}
          getOptionLabel={(option) => option.label}
          onChange={(event, option) => {
            setDistributorType(option);
            handleFormChange("distributorType", null, true, { ...option });
          }}
          markers={JSON.stringify({
            left: "add_distributor_due_date_type",
            right: "add_distributor_credit_days",
          })}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput
          id="add_distributor_credit_days"
          name="creditDays"
          ref={addDistributorCreditDaysRef}
          label="Credit Days"
          isAllowed={withDaysCap}
          allowNegative={false}
          decimalScale={0}
          onFocus={() => setCurrentComponent("add_distributor_contact")}
          value={formState?.creditDays}
          onBlur={() => validateForm("creditDays", localFormState, errorState)}
          onChange={(e) => {
            setLocalFormState((prev) => {
              return { ...prev, creditDays: e.target.value };
            });
            handleFormChange("creditDays", e.target.value);
            removeErrorStateOnChange("add_distributor_credit_days");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_purchase_email",
              down: "add_distributor_manufacturers",
              left: "add_distributor_type",
              right: "add_distributor_manufacturers",
            }),
          }}
          required={false}
          error={checkErrorStateExists(
            "add_distributor_credit_days",
            errorState
          )}
        />
      </Grid>
      <Grid item xs={9}>
        <ChipInputSelect
          label="Manufacturer"
          id="add_distributor_manufacturers"
          name="manufacturers"
          ref={addDistributorManufacturersRef}
          onFocus={() => setCurrentComponent("add_distributor_manufacturers")}
          value={selectedManufactures}
          options={manufactures}
          onInputChange={manufacturerChangedHandler}
          noOptionsText="Search Manufacturers"
          getOptionLabel={(option) => option.manufacturerName}
          isOptionEqualToValue={(option, value) => {
            return option.manufacturerId === value.manufacturerId;
          }}
          onChange={(event, value) => {
            handleFormChange("manufacturers", value);
            setSelectedManufactures(value);
          }}
          disableCloseOnSelect={true}
          blurOnSelect={false}
          markers={JSON.stringify({
            left: "add_distributor_credit_days",
            right: "add_distributor_lock",
          })}
        />
      </Grid>
      <Grid item xs={3}>
        <Switch
          id="add_distributor_lock"
          name="isLocked"
          ref={addDistributorLockRef}
          label="Lock Purchase PO"
          checked={(formState && formState.isLocked) || false}
          onFocus={() => setCurrentComponent("add_distributor_lock")}
          onChange={(e) => {
            handleFormChange("isLocked", e.target.checked);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              left: "add_distributor_manufacturers",
              right: "add_distributor_name",
            }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default GeneralTab;
